import PFDinDisplayProWoff from '../../../Fonts/PFDinDisplayPro-Light.woff'
import PFDinDisplayProEot from '../../../Fonts/PFDinDisplayPro-Light.eot'
import PFDinDisplayProTtf from '../../../Fonts/PFDinDisplayPro-Light.ttf'
import { COLORS } from '../colors'

const font = {
  fontFamily: 'PFDinDisplayPro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: ` 
        url(${PFDinDisplayProWoff}) format('woff'),
        url(${PFDinDisplayProEot}) format('embedded-opentype'),
        url(${PFDinDisplayProTtf}) format('truetype')
  `
}

export const MuiCssBaseline = {
  '@global': {
    '@font-face': [font],
    '*::-webkit-scrollbar': {
      width: '12px'
    },
    '*::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.5)',
      '&:active': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.8)'
      }
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: '10px'
    },
    a: {
      color: COLORS.white
    }
  }
}
